import React from 'react'
import erpColumns from './erpColumns'
import Orders from './Orders'
import listOrderTypes from './gql/listOrderTypes'
import getOrderType from './gql/getOrderType'
import updateOrderType from './gql/updateOrderType'
import SideListHeader from './SideListHeader'
import createOrderType from './gql/createOrderType'

const sections = (t, showCashRegistersModal, toggleCashRegisterModal) => ([{
	label: t('options_section.sub_sections.order'),
	link: 'erp',
	columns: erpColumns(t),
	listQuery: listOrderTypes,
	itemQuery: getOrderType,
	createMutation: createOrderType,
	requiredFields: ['code', 'name', 'type'],
	addNewRecord: true,
	typename: 'OrderType',
	subsections: [{
		link: '',
		component: Orders,
		updateMutation: updateOrderType,
		fields: ['code', 'name', 'dateSpan', 'firstDate', 'reportCount', 'isActive', 'isMon', 'isTue', 'isWed', 'isThu', 'isFri', 'isSat', 'isSun', 'rawCreditClientId', 'storageRelationId', 'orderTypeStandartised', 'showAllButton', 'isTemplateMode']
	}],
	sideListProps: {
		datatableProps: {
			defaultSorted: [{
				id: 'code'
			}],
			label: <SideListHeader toggleCashRegisterModal={toggleCashRegisterModal} />
		}
	},
	itemViewProps: { showCashRegistersModal, toggleCashRegisterModal }
}])

export default sections

